export default "https://legacy.eskolare-development.com/images/error.png";